import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-500.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-700.css';

import "react-google-reviews/dist/index.css";
import wrapPageElements from './wrap-page-element';
import wrapWithProviders from './wrap-with-providers';
export const wrapPageElement = wrapPageElements

export const wrapRootElement = wrapWithProviders
